class StoresTabs extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[data-store-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-store-panel]'));
    this.media = Array.from(this.querySelectorAll('[data-store-media]'));

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.activate(tab.dataset.storeTab));
      tab.addEventListener('keydown', (e) => this.handleKeydown(e));
    });
  }

  activate(id) {
    this.tabs.forEach((t) => {
      const isActive = t.dataset.storeTab === id;
      t.classList.toggle('is-active', isActive);
      t.setAttribute('aria-selected', isActive ? 'true' : 'false');
      t.setAttribute('tabindex', isActive ? '0' : '-1');
    });
    this.panels.forEach((p) => {
      p.classList.toggle('is-active', p.dataset.storePanel === id);
    });
    this.media.forEach((m) => {
      m.classList.toggle('is-active', m.dataset.storeMedia === id);
    });
  }

  handleKeydown(e) {
    const currentIdx = this.tabs.findIndex((t) => t === e.target);
    if (currentIdx === -1) return;

    let nextIdx = null;
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
      nextIdx = (currentIdx + 1) % this.tabs.length;
    } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
      nextIdx = (currentIdx - 1 + this.tabs.length) % this.tabs.length;
    } else if (e.key === 'Home') {
      nextIdx = 0;
    } else if (e.key === 'End') {
      nextIdx = this.tabs.length - 1;
    }

    if (nextIdx !== null) {
      e.preventDefault();
      this.activate(this.tabs[nextIdx].dataset.storeTab);
      this.tabs[nextIdx].focus();
    }
  }
}

if (!customElements.get('stores-tabs')) {
  customElements.define('stores-tabs', StoresTabs);
}